/* ============================================================
   KABLA · Recomendador inteligente — DATOS
   ============================================================ */
window.KABLA_RECO_DATA = (function () {
  'use strict';

  var IMG_BASE = window.KABLA_RECO_IMG_BASE || "https://cdn.shopify.com/s/files/1/0616/5597/3975/files/";

  var RAW = [
    [41993131163735,'Panel de 2 parámetros (COC/THC) Certum - Kit con 25','CERTUM',629.00,1,'DOA-124.png'],
    [41912055234647,'Panel de 2 parámetros (MQL/LSD) Certum - Kit con 25','CERTUM',1439.00,1,'PanelMetacualonayLSDCertum.png'],
    [41965462847575,'Panel de 2 parámetros (ETG/COT) Certum - Kit con 25','CERTUM',1049.00,1,'doa-124-2_11_9_2025_10_28_33_575.png'],
    [41819465973847,'Panel de 3 parámetros (AMP/COC/THC) Certum - Kit con 25','CERTUM',809.00,0,'Panelde3parametrosCertum.png'],
    [41965626196055,'Panel de 4 parámetros (AMP/COC/MET/THC) Certum - Kit con 25','CERTUM',1259.00,0,'DOA-144-THC-COC-AMP-MET.png'],
    [41965655785559,'Panel de 5 parámetros (AMP/BZD/COC/MET/OPI) Certum - Kit con 25','CERTUM',1569.00,1,'DOA-154-3_f1bf2a66-8479-4785-890c-f0455e29273e.png'],
    [42447971385431,'Panel de 9 parámetros (AMP/BAR/BZD/COC/MET/MOR/MTD/PCP/THC) Certum - Kit con 25','CERTUM',2179.00,1,'51f8dcb7..jpg'],
    [42309955747927,'Panel de 3 parámetros (COC/MET/THC) Fastline - Kit con 25','FASTLINE',989.00,1,'PANEL3-2-FL-P031.png'],
    [42309955780695,'Panel de 3 parámetros (AMP/COC/THC) Fastline - Kit con 25','FASTLINE',989.00,1,'PANEL3-2-FL-P032.png'],
    [42309955846231,'Panel de 5 parámetros (AMP/BZD/COC/MET/THC) Fastline - Kit con 25','FASTLINE',1399.00,1,'PANEL5-2-FL-P053.png'],
    [42309955715159,'Panel de 6 parámetros (AMP/BZD/COC/MET/OPI/THC) Fastline - Kit con 25','FASTLINE',1619.00,1,'PANEL6-2-FL-P061.png'],
    [42416085598295,'Panel de 2 parámetros (BZD/FYL) One Second - Kit con 25','PROVISION',559.00,1,'2-PGP-P021-Panelde2parametrosProvision.png'],
    [42410347200599,'Panel de 3 parámetros (COC/MET/THC) One Second - Kit con 25','PROVISION',679.00,1,'2-PGC-P031-COC-MET-THC.png'],
    [42416176463959,'Panel de 3 parámetros (COC/MET/THC) One Second - Kit con 25','PROVISION',679.00,1,'2-PGP-P031.png'],
    [42416183443543,'Panel de 3 parámetros (COC/AMP/THC) One Second - Kit con 25','PROVISION',679.00,1,'2-PGP-P032.png'],
    [42417600168023,'Panel de 4 parámetros (COC/MET/THC/AMP) One Second - Kit con 25','PROVISION',889.00,1,'2-PGP-P043.png'],
    [42416027828311,'Panel de 5 parámetros (COC/AMP/MET/THC/OPI) One Second - Kit con 25','PROVISION',1039.00,1,'2-PGP-P051PanelAntidoping5parametrosProvision.png'],
    [42416045850711,'Panel de 5 parámetros (THC/COC/MET/AMP/BZD) One Second - Kit con 25','PROVISION',1039.00,1,'2-PGP-P053PanelOneSecond5parametros.png'],
    [42410842357847,'Panel de 6 parámetros (AMP/BZD/COC/MET/OPI/THC) One Second - Kit con 25','PROVISION',1209.00,1,'Panel6OneSecond-2-PGC-P061.png'],
    [42417647648855,'Panel de 6 parámetros (COC/THC/MET/AMP/OPI/MDMA) One Second - Kit con 25','PROVISION',1209.00,1,'2-PGP-P066.png'],
    [42417751818327,'Panel de 7 parámetros (COC/AMP/MET/THC/OPI/BZD/BAR) One Second - Kit con 25','PROVISION',1469.00,1,'2-PGP-P072.png'],
    [42418053644375,'Panel de 8 parámetros (FYL/THC/MDMA/COC/BZD/MET/AMP/OPI) One Second - Kit con 25','PROVISION',1679.00,1,'2-PGP-P084.png'],
    [42419359088727,'Panel de 10 parámetros (AMP/BAR/BZD/COC/MDMA/MET/MTD/PCP/TCA/THC) One Second - Kit con 25','PROVISION',1989.00,1,'PanelOneSecond10parametros.png'],
    [41820847734871,'Frasco Split Screen Cup de 5 parámetros (AMP/COC/MET/OPI/THC) Certum - Kit con 25','CERTUM',2759.00,1,'split-screen-cup-certum-diagnostics.png'],
    [41820867231831,'Frasco Split Screen Cup de 6 parámetros (AMP/BZD/COC/MET/OPI/THC) Certum - Kit con 25','CERTUM',2899.00,1,'split-screen-cup-certum-diagnostics.png'],
    [41820882206807,'Frasco Split Screen Cup de 10 parámetros (AMP/BAR/BZD/COC/MDMA/MET/OPI/PCP/TCA/THC) Certum - Kit con 25','CERTUM',3519.00,1,'split-screen-cup-certum-diagnostics.png'],
    [41991169769559,'Frasco Simple Cup de 3 Parámetros (MET/COC/THC) Certum - Kit con 25','CERTUM',1789.00,1,'hcdoab-234_22_9_2025_16_57_20_393.png'],
    [41991169933399,'Frasco Simple Cup de 3 Parámetros (AMP/COC/THC) Certum - Kit con 25','CERTUM',1789.00,1,'e884b29d..jpg'],
    [41821655564375,'Frasco Simple Cup de 5 parámetros (AMP/COC/MET/MOR/THC) Certum - Kit con 25','CERTUM',2069.00,1,'SimpleCup5parametrosHCDOAB-255.5.png'],
    [41992699969623,'Frasco Simple Cup de 5 Parámetros (AMP/BAR/BZD/COC/THC) Certum - Kit con 25','CERTUM',2069.00,1,'hcdoab-1254_22_9_2025_16_48_8_619.png'],
    [41821703438423,'Frasco Simple Cup de 5 parámetros (AMP/BZD/COC/MET/THC) Certum - Kit con 25','CERTUM',2069.00,1,'SimpleCup5parametrosHCDOAB-1154.png'],
    [41992701083735,'Frasco Simple Cup de 5 Parámetros (AMP/COC/OPI/PCP/THC) Certum - Kit con 25','CERTUM',2069.00,1,'hcdoab-154_22_9_2025_14_43_24_161.png'],
    [41992701771863,'Frasco Simple Cup de 5 Parámetros (AMP/COC/MET/PCP/THC) Certum - Kit con 25','CERTUM',1379.00,1,'hcdoab-1454_22_9_2025_16_52_48_292.png'],
    [41821717856343,'Frasco Simple Cup de 6 parámetros (AMP/OPI/BZD/COC/MET/THC) Certum - Kit con 25','CERTUM',2209.00,1,'HCDOAB-264.png'],
    [41992933736535,'Frasco Simple Cup de 6 Parámetros (AMP/BAR/BZD/COC/MET/THC) Certum - Kit con 25','CERTUM',2209.00,1,'hcdoab-1164.6_22_9_2025_16_55_19_452.png'],
    [41992933769303,'Frasco Simple Cup de 6 Parámetros (AMP/BZD/COC/MET/PCP/THC) Certum - Kit con 25','CERTUM',2209.00,1,'26cffeec..jpg'],
    [41992933965911,'Frasco Simple Cup de 6 Parámetros (AMP/COC/MET/MOR/PCP/THC) Certum - Kit con 25','CERTUM',2209.00,1,'82fefad4..jpg'],
    [41992941240407,'Frasco Simple Cup de 7 Parámetros (AMP/BAR/BZD/COC/MET/MOR/THC) Certum - Kit con 25','CERTUM',2349.00,1,'c9670abd..jpg'],
    [41821725589591,'Frasco Simple Cup de 10 parámetros (AMP/COC/THC/MET/MOR/BZD/XTC/BAR/PCP/MTD) Certum - Kit con 25','CERTUM',2759.00,1,'hcdoab-3104_23_9_2025_11_39_24_895.png'],
    [42328902533207,'Frasco de 8 parámetros (AMP/COC/FYL/MDMA/MET/MPD/OPI/THC) Fastline - Kit con 25','FASTLINE',2579.00,0,'2-FL-V083-fastline.png'],
    [42423981572183,'Frasco de 5 parámetros (COC/AMP/MET/THC/BZD) One Second - Kit con 25','PROVISION',1909.00,1,'2-PGC-V053FrascodeDrogasOneSecond.png'],
    [42423983341655,'Frasco de 5 parámetros (COC/AMP/MET/THC/OPI) One Second - Kit con 25','PROVISION',1909.00,1,'2-PGC-V051Panel5OneSecond.png'],
    [42423999692887,'Frasco de 6 parámetros (COC/AMP/MET/THC/OPI/BZD) One Second - Kit con 25','PROVISION',3079.00,1,'2-PGC-V061.png'],
    [42424194269271,'Prueba en saliva 5 parámetros (COC/AMP/MET/THC/OPI) en pluma ProVision - Kit con 25','PROVISION',2449.00,1,'PruebaAntidopingenSalivaOneSecond.png'],
    [42424219566167,'Prueba en saliva 6 parámetros (COC/AMP/MET/THC/OPI/BZD) en pluma ProVision - Kit con 25','PROVISION',2679.00,1,'PruebaAntidopingenSalivaOneSecond.png'],
    [42424275107927,'Prueba en saliva 5 parámetros (COC/AMP/MET/THC/OPI) en copa ProVision - Kit con 25','PROVISION',2989.00,1,'2-PS-C0510.png'],
    [42448116875351,'Prueba de Drogas en Saliva de 5 parámetros (AMP/COC/OPI/MET/THC) Certum - Kit con 20','CERTUM',2689.00,1,'d9fbeb7a..jpg'],
    [42448217276503,'Prueba de Drogas en Saliva de 7 parámetros (AMP/BAR/BZD/COC/FYL/MET/THC) Certum - Kit con 20','CERTUM',1959.00,1,'d9fbeb7a..jpg'],
    [41808448094295,'Prueba de Anfetamina en Tira Certum - Kit con 50','CERTUM',609.00,1,'prueba_de_anfetamina_en_tira_certum.png'],
    [41808448159831,'Prueba de Barbitúricos en Tira Certum - Kit con 50','CERTUM',539.00,0,'prueba_de_barbituricos_en_tira_certum.png'],
    [41808448192599,'Prueba de Benzodiacepina en Tira Certum - Kit con 50','CERTUM',659.00,1,'prueba_de_benzodiacepinas_en_tira_certum.png'],
    [41808448225367,'Prueba de Cocaína en Tira Certum - Kit con 50','CERTUM',659.00,1,'prueba_de_cocaina_en_tira_certum.png'],
    [41808448290903,'Prueba de LSD en Tira Certum - Kit con 50','CERTUM',3589.00,1,'prueba_de_lsd_en_tira_certum.png'],
    [41808448553047,'Prueba de Metanfetamina en Tira Certum - Kit con 50','CERTUM',539.00,1,'prueba_de_metanfetamina_en_tira_certum.png'],
    [41808448585815,'Prueba de Metilfenidato en Tira Certum - Kit con 50','CERTUM',2199.00,1,'prueba_de_metilfenidato_en_tira_certum.png'],
    [41808448651351,'Prueba de Opiáceos en Tira Certum - Kit con 50','CERTUM',549.00,1,'prueba_de_opiaceos_en_tira_certum.png'],
    [41808448684119,'Prueba de Fenciclidina en Tira Certum - Kit con 50','CERTUM',549.00,1,'prueba_de_fenciclidina_en_tira_certum.jpg'],
    [41808448782423,'Prueba de Marihuana en Tira Certum - Kit con 50','CERTUM',659.00,1,'prueba_de_marihuana_en_tira_certum.png'],
    [41815612129367,'Prueba de Anfetamina en Cassette Certum - Kit con 40','CERTUM',719.00,1,'Cassette_Certum_para_deteccion_de_Anfetamina.png'],
    [41815612162135,'Prueba de Barbitúrico en Cassette Certum - Kit con 40','CERTUM',579.00,0,'Cassette_Certum_para_deteccion_de_Barbituricos.png'],
    [41815612194903,'Prueba de Benzodiacepina en Cassette Certum - Kit con 40','CERTUM',529.00,0,'Cassette_Certum_para_deteccion_de_Benzodiacepinas.png'],
    [41815612227671,'Prueba de Cocaína en Cassette Certum - Kit con 40','CERTUM',579.00,1,'Cassette_Certum_para_deteccion_de_Cocaina.png'],
    [41815612260439,'Prueba de ETG en Cassette Certum - Kit con 40','CERTUM',2249.00,1,'Cassette_Certum_para_deteccion_de_Etilglucuronido.png'],
    [41815612293207,'Prueba de LSD en Cassette Certum - Kit con 40','CERTUM',2499.00,1,'Cassette_Certum_para_deteccion_de_LSD.png'],
    [41815612325975,'Prueba de Éxtasis en Cassette Certum - Kit con 40','CERTUM',529.00,1,'Cassette_Certum_para_deteccion_de_Extasis.png'],
    [41815612358743,'Prueba de Metanfetamina en Cassette Certum - Kit con 40','CERTUM',579.00,1,'Cassette_Certum_para_deteccion_de_Metanfetamina.png'],
    [41815612391511,'Prueba de Opiáceos en Cassette Certum - Kit con 40','CERTUM',579.00,1,'Cassette_Certum_para_deteccion_de_Opiaceos.png'],
    [41815612424279,'Prueba de TCA en Cassette Certum - Kit con 40','CERTUM',709.00,0,'Cassette_Certum_para_deteccion_de_TCA.png'],
    [41815612457047,'Prueba de Marihuana en Cassette Certum - Kit con 40','CERTUM',599.00,1,'Cassette_Certum_para_deteccion_de_Marihuana.png'],
    [41816785518679,'Prueba de Fentanilo en Cassette Certum - Kit con 40','CERTUM',629.00,1,'Cassette_Certum_para_deteccion_de_Fentanilo.png'],
    [41816785715287,'Prueba de Metilfenidato en Cassette Certum - Kit con 40','CERTUM',2079.00,1,'Cassette_Certum_para_deteccion_de_Feniciclidina.png'],
    [41816785911895,'Prueba de Fenciclidina en Cassette Certum - Kit con 40','CERTUM',629.00,1,'Cassette_Certum_para_deteccion_de_Feniciclidina.png'],
    [41765800509527,'Prueba De Metanfetamina En Cassette Instant-view - Kit De 25','INSTANT-VIEW',589.00,1,'TCH.png'],
    [41765800575063,'Prueba De Marihuana Thc En Cassette Instant-view - Kit De 25','INSTANT-VIEW',589.00,1,'TCH.png'],
    [41765800247383,'Prueba De Cocaína En Cassette Instant-view - Kit Con 25','INSTANT-VIEW',589.00,1,'db3a546f._4314677c-2c75-48ea-9085-b9516a3bc35d.jpg'],
    [41765800378455,'Prueba De Opiáceos 2000 En Cassette Instant-view - Kit De 25','INSTANT-VIEW',559.00,1,'1aff1d12._50a9c8f3-d5da-4065-ad0a-c7ca49e1d7b5.jpg'],
    [41765800280151,'Prueba De Barbitúricos En Cassette Instant-view - Kit De 25','INSTANT-VIEW',589.00,1,'TCH.png'],
    [41765799952471,'Prueba De Cocaína 150 En Cassette Instant-view - Kit Con 25','INSTANT-VIEW',589.00,1,'TCH.png'],
    [41765799985239,'Prueba De Fenciclidina En Cassette Instant-view - Kit Con 25','INSTANT-VIEW',589.00,1,'fc839c6f._cf3c143a-533f-4924-bedf-edbc958149f8.jpg'],
    [41765800640599,'Prueba De Benzodiazepina En Cassette Instant-view - Kit C/25','INSTANT-VIEW',589.00,1,'TCH.png'],
    [41765799886935,'Prueba De Anfetaminas En Cassette Instant-view - Kit Con 25','INSTANT-VIEW',589.00,1,'AMP.png'],
    [43935613485143,'Prueba de Drogas en Saliva de 6 parámetros (AMP/BAR/BZD/COC/MET/THC) Certum - Kit con 20','CERTUM',2959.00,1,'fccdde76..jpg'],
    [44055455694935,'Panel de 5 parámetros (AMP/COC/MET/OPI/THC) Certum','CERTUM',979.00,1,'new_image_url-20-7-2026-18-6-34-41919756-bac65095.jpg']
  ];

  var PARAM_INFO = {
    AMP:{n:'Anfetaminas',c:'est'}, MET:{n:'Metanfetamina',c:'est'}, COC:{n:'Cocaína',c:'est'},
    MDMA:{n:'Éxtasis (MDMA)',c:'est'}, MPD:{n:'Metilfenidato',c:'est'},
    OPI:{n:'Opiáceos',c:'dep'}, BZD:{n:'Benzodiacepinas',c:'dep'}, BAR:{n:'Barbitúricos',c:'dep'},
    MOR:{n:'Morfina',c:'dep'}, MTD:{n:'Metadona',c:'dep'}, FYL:{n:'Fentanilo',c:'dep'},
    THC:{n:'Marihuana',c:'hal'}, LSD:{n:'LSD',c:'hal'}, PCP:{n:'Fenciclidina',c:'hal'},
    ETG:{n:'Alcohol (ETG)',c:'otr'}, COT:{n:'Cotinina',c:'otr'}, MQL:{n:'Metacualona',c:'otr'}, TCA:{n:'Tricíclicos',c:'otr'}
  };

  var PARAM_GROUPS = [
    { label:'Estimulantes', codes:['AMP','MET','COC','MDMA','MPD'] },
    { label:'Depresores y opioides', codes:['OPI','BZD','BAR','MOR','MTD','FYL'] },
    { label:'Cannabis y alucinógenos', codes:['THC','LSD','PCP'] },
    { label:'Otros marcadores', codes:['ETG','COT','MQL','TCA'] }
  ];

  var CAT_COLOR = { est:'#FF9900', dep:'#E07F00', hal:'#B85C00', otr:'#8A4B10' };

  var FORMATS = [
    { key:'Panel',    label:'Panel',              desc:'Tarjeta multiparámetro en una sola prueba de orina.' },
    { key:'Frasco',   label:'Frasco / Vaso',      desc:'Vaso recolector con lectura integrada. Higiénico.' },
    { key:'Saliva',   label:'Saliva (oral)',      desc:'No invasiva, sin muestra de orina.' },
    { key:'Tira',     label:'Tira reactiva',      desc:'Tira individual económica, un parámetro.' },
    { key:'Cassette', label:'Casete individual', desc:'Casete con gotero, alta precisión.' }
  ];

  var BRANDS = [
    { key:'CERTUM',       label:'Certum',                 desc:'El catálogo más amplio: paneles, frascos, tiras, casetes y saliva.' },
    { key:'PROVISION',    label:'ProVision · One Second', desc:'Paneles, frascos y pruebas en saliva de la línea One Second.' },
    { key:'FASTLINE',     label:'Fastline',               desc:'Paneles y frascos multiparámetro de detección rápida.' },
    { key:'INSTANT-VIEW', label:'Instant-View',           desc:'Casetes individuales económicos por parámetro.' }
  ];

  var USO_OPTIONS = [
    { key:'Empresa',  label:'Empresa / RH',          sub:'Programa interno de detección', score:3, icon:'building' },
    { key:'Clínica',  label:'Clínica / laboratorio', sub:'Servicio a terceros',           score:3, icon:'cross' },
    { key:'Escuela',  label:'Escuela / gobierno',    sub:'Institución o dependencia',     score:2, icon:'school' },
    { key:'Personal', label:'Uso personal / familiar', sub:'Una o pocas pruebas',         score:0, icon:'user' }
  ];

  var SECTOR_OPTIONS = [
    { key:'Construcción', icon:'<path d="M2 20h20M4 20V10l8-6 8 6v10M9 20v-6h6v6"/>' },
    { key:'Manufactura',  icon:'<path d="M2 20h20M2 20V9l5 4V9l5 4V9l5 4v7"/>' },
    { key:'Transporte',   icon:'<path d="M1 3h15v13H1zM16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>' },
    { key:'Oil & Gas',    icon:'<path d="M12 2s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/>' },
    { key:'Minería',      icon:'<path d="M3 21h18M6 21V10l4-4 4 4v11M14 21V13l3-3 3 3v8"/>' },
    { key:'Logística',    icon:'<path d="M21 8l-9-5-9 5v8l9 5 9-5V8zM3 8l9 5 9-5M12 13v8"/>' },
    { key:'Salud',        icon:'<path d="M12 5v14M5 12h14"/>' },
    { key:'Otro',         icon:'<circle cx="12" cy="12" r="9"/><path d="M12 8v.01M12 11v5"/>' }
  ];

  var VOLUMEN_OPTIONS = [
    { key:'1 – 25',    sub:'Un kit alcanza el mes', score:0, tests:25 },
    { key:'26 – 100',  sub:'2 a 4 kits al mes',     score:2, tests:100 },
    { key:'101 – 500', sub:'Programa recurrente',    score:4, tests:500 },
    { key:'+500',      sub:'Volumen corporativo',   score:5, tests:750 }
  ];

  var URGENCIA_OPTIONS = [
    { key:'Esta semana',       sub:'Necesito surtir de inmediato', score:5, dot:'#8A4B10' },
    { key:'Este mes',          sub:'Estoy armando el programa',    score:3, dot:'#C06000' },
    { key:'Próximos 3 meses',  sub:'Voy planeando con calma',      score:1, dot:'#FF9900' },
    { key:'Solo estoy viendo', sub:'Estoy comparando opciones',    score:0, dot:'#FFB347' }
  ];

  var NAME_TO_CODE = [
    [/metanfetamin/i,'MET'], [/metilfenidato/i,'MPD'], [/anfetamin/i,'AMP'],
    [/barbit/i,'BAR'], [/benzodia/i,'BZD'], [/cocaína|cocaina/i,'COC'],
    [/opiáceos|opiaceos/i,'OPI'], [/fenciclidin/i,'PCP'], [/marihuana/i,'THC'],
    [/\blsd\b/i,'LSD'], [/\betg\b|etilgluc/i,'ETG'], [/éxtasis|extasis/i,'MDMA'],
    [/fentanilo/i,'FYL'], [/\btca\b/i,'TCA']
  ];

  function detectFormat(t) {
  var s = String(t).toLowerCase();
  if (s.indexOf('saliva') > -1) return 'Saliva';
  if (s.indexOf('frasco') > -1 || s.indexOf('cup') > -1 || s.indexOf('vaso') > -1) return 'Frasco';
  if (s.indexOf('tira') > -1) return 'Tira';
  if (s.indexOf('cassette') > -1 || s.indexOf('casete') > -1) return 'Cassette';
  return 'Panel';
}

  function detectParams(title) {
  var out = [];
  var m = title.match(/\(([^)]+)\)/);

  // Extrae y limpia todas las siglas separadas por /, guión, coma o espacio
  if (m) {
    m[1].split(/[\/\s·,-]+/).forEach(function (x) {
      var c = x.trim().toUpperCase();
      if (c === 'XTC') c = 'MDMA';
      if (PARAM_INFO[c] && out.indexOf(c) === -1) out.push(c);
    });
  }

  // Complementa buscando nombres completos en el título
  for (var i = 0; i < NAME_TO_CODE.length; i++) {
    if (NAME_TO_CODE[i][0].test(title)) {
      var code = NAME_TO_CODE[i][1];
      if (out.indexOf(code) === -1) out.push(code);
    }
  }

  return out;
}

  function detectKit(title) {
    var m = title.match(/kit\s*(?:con|de|c\/)?\s*(\d+)/i);
    return m ? parseInt(m[1], 10) : null;
  }

  function normalizeBrand(vendor) {
  var v = String(vendor || '').toUpperCase().trim();

  if (v.indexOf('CERTUM') > -1) return 'CERTUM';

  if (
    v.indexOf('PROVISION') > -1 ||
    v.indexOf('ONE SECOND') > -1 ||
    v.indexOf('PRO-VISION') > -1
  ) return 'PROVISION';

  if (v.indexOf('FASTLINE') > -1) return 'FASTLINE';

  if (v.indexOf('INSTANT') > -1) return 'INSTANT-VIEW';

  return v || 'CERTUM';
}

  if (window.KABLA_RECO_RAW && window.KABLA_RECO_RAW.length > 0) { 
    RAW = window.KABLA_RECO_RAW; 
  }

  var PRODUCTS = RAW.map(function (r) {
    var imgUrl = r[5] || '';
    if (imgUrl && !imgUrl.startsWith('http://') && !imgUrl.startsWith('https://') && !imgUrl.startsWith('//')) {
      imgUrl = IMG_BASE + imgUrl;
    }
    return {
      vid: r[0], 
      title: r[1], 
      brand: normalizeBrand(r[2]), 
      price: r[3], 
      avail: !!r[4],
      img: imgUrl, 
      format: detectFormat(r[1]),
      params: detectParams(r[1]), 
      kit: detectKit(r[1])
    };
  });

  return {
    PRODUCTS: PRODUCTS,
    PARAM_INFO: PARAM_INFO,
    PARAM_GROUPS: PARAM_GROUPS,
    CAT_COLOR: CAT_COLOR,
    FORMATS: FORMATS,
    BRANDS: BRANDS,
    USO_OPTIONS: USO_OPTIONS,
    SECTOR_OPTIONS: SECTOR_OPTIONS,
    VOLUMEN_OPTIONS: VOLUMEN_OPTIONS,
    URGENCIA_OPTIONS: URGENCIA_OPTIONS
  };
})();